
            <div class="swiper-container swiper-nav-bullets swiper-logos-institutions" style="margin: -30px 0 0 0;">
               
                <swiper [config]="swiperConfig">

                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/1.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/2.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/3.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/4.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/5.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/6.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/7.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/8.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/9.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/10.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/11.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/12.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/13.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/14.png" />
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div><img class="swiper-lazy institution-logo" alt="Logo" src="images/emp/15.png" />
                        </div>
                    </ng-template>
                </swiper>
  
                <div id="swiper-employer-list" class="swiper-pagination"></div>
                <div class="controls-swiper-wrapper-2">
                    <div id="swiper-employer-list-prev" class="swiper-button-prev swiper-card-prev"></div>
                    <div id="swiper-employer-list-next" class="swiper-button-next swiper-card-next"></div>
                </div>
            </div>
        
